module.exports = __webpack_public_path__ + "img/tab-placeholder-horizontal.c7abab92.svg";